import { useState, useCallback } from 'react'

export function useAuthViewModel(authService) {
  const [mode, setMode] = useState('signIn') // 'signIn' | 'signUp'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [fullName, setFullName] = useState('')
  const [status, setStatus] = useState('idle') // 'idle' | 'loading' | 'error'
  const [errorMessage, setErrorMessage] = useState('')

  const submit = useCallback(async () => {
    if (!email || !password) {
      setStatus('error')
      setErrorMessage('Please enter your email and password.')
      return
    }
    if (mode === 'signUp' && !fullName) {
      setStatus('error')
      setErrorMessage('Please enter your name.')
      return
    }

    setStatus('loading')
    setErrorMessage('')

    try {
      if (mode === 'signIn') {
        await authService.signIn(email, password)
      } else {
        await authService.signUp(email, password, fullName)
      }
      setStatus('idle')
    } catch (err) {
      setStatus('error')
      setErrorMessage(err?.message || 'Something went wrong. Please try again.')
    }
  }, [authService, mode, email, password, fullName])

  const switchMode = useCallback(() => {
    setMode((m) => (m === 'signIn' ? 'signUp' : 'signIn'))
    setStatus('idle')
    setErrorMessage('')
  }, [])

  return {
    mode,
    email, setEmail,
    password, setPassword,
    fullName, setFullName,
    status,
    errorMessage,
    submit,
    switchMode,
  }
}
